/** @jsxImportSource @emotion/react */
import { definitions } from "../../../schema/api";
import Folder from "@material-ui/icons/Folder";

interface BreadcrumbsProps {
  list: definitions["ShareResource"][];
  onClickFolder: (id: number) => void | Promise<void>;
}

const labels = {
  shareResource: "共有資料",
};

const styles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    ["& > div"]: {
      display: "flex",
      alignItems: "center",
      gap: "0.2rem",
    },
  },
  link: {
    cursor: "pointer",
    ["&:hover"]: {
      textDecoration: "underline",
      color: "#0000aa",
    },
  },
};

function Breadcrumbs(props: BreadcrumbsProps) {
  const onClick = (param: definitions["ShareResource"]) => {
    if (param.type !== "folder") {
      return;
    }
    props.onClickFolder(param.id);
  };

  return (
    <div css={styles.wrapper}>
      <div
        {
          ...(props.list.length ? {
            onClick: () => props.onClickFolder(0),
            css: styles.link,
          } : {})
        }
      >
        <Folder />
        {labels.shareResource}
      </div>
      {props.list.map((item, i) => (
        <>
          <div>≫</div>
          <div
            {
              ...(i < props.list.length - 1 ? {
                onClick: () => onClick(item),
                css: styles.link,
              } : {})
            }
            key={`breadcrumb.${i}`}
          >
            <Folder />
            <span>{item.name}</span>
          </div>
        </>
      ))}
    </div>
  );
}

export { Breadcrumbs };
